module.exports = __webpack_public_path__ + "images/pie-chart-icon-9d96d8e5.svg";